import React from 'react';
import { Modal, ModalFooter, ModalBody } from 'reactstrap';

const WellnessInfowindow = ({ showInfo, toggle, technicalHelpDeskNumber, technicalHelpDeskHours}) => {
    return (<Modal className="wellness-info-modal" isOpen={showInfo} toggle={toggle} centered backdrop>
        <ModalBody>
            <div className="row">
                <div className="col-12">
                    <div className="info-heading">
                        <span className="svg-trophy" />
                        <h1 className="heading">Well-Being Journeys & Resources</h1>
                    </div>
                </div>
                <div className="col-12">
                    <p> To help you take the first steps in achieving your Well-being goals, Well-being Journeys set you on a path of education and activities to promote awareness in the areas you are interested in.</p>
                    <ul className="angle-bullets">
                        <li>To begin, select <span className="strong">"Get Started"</span>.</li>
                        <li>Once enrolled you can find your <span className="strong">Well-being Journey</span> in the <span className="strong">Care Coach</span> tile on the home screen of your app, there a welcome message and introduction video will be waiting for you.</li>
                        <li>Follow the prompts and complete the activities to move on to the next step.</li>
                        <li>You can complete these journeys as fast as you would like, but we encourage you spend at least a few days, trying to be mindful of the goal you want to reach.</li>
                        <li>You can return to the Care Coach tile at any time to pick up where you left off, or to review your responses and progress.</li>
                    </ul>
                </div>
                <div className="col-12">
                    If you are having trouble accessing a <span className="strong">Well-being Journey</span>, call the <span className="strong">MyBSWHealth technical help desk</span> {technicalHelpDeskHours} at <a href={`tel:${technicalHelpDeskNumber}`}>{technicalHelpDeskNumber}</a>.
                </div>
            </div>
        </ModalBody>
        <ModalFooter><button className="btn text-btn" onClick={toggle}>OKAY</button></ModalFooter>
    </Modal>);
};

export default WellnessInfowindow;